import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/** Full subscription + usage (unchanged legacy call). */
export function useMySubscription() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["subscription-me", user?.id],
    queryFn: async () => (await sharedApi.get("/classifieds/subscriptions/me")).data,
    enabled: !!user,
    staleTime: 30_000,
  });
}

/** Compact plan-usage banner data — matches the legacy "Active Plan · Remaining Posts: N" widget. */
export function usePlanUsage() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["plan-usage", user?.id],
    queryFn: async () => (await sharedApi.get("/classifieds/my/plan-usage")).data,
    enabled: !!user,
    staleTime: 30_000,
    retry: 0,
  });
}
